export const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  customValid: {
    minHeight: "1rem",
    marginTop: "0px",
    padding: "6px 12px 6px 12px",
  },
  customInValid: {
    minHeight: "1rem",
    fontSize: "0.8rem",
    marginTop: "0px",
    padding: "6px 12px 6px 12px",
  },
  textField: {
    width: "100%",
  },
  button: {
    cursor: "pointer",
    // paddingBottom: theme.spacing(2),
    // paddingTop: theme.spacing(2),
  },
  menuItem: {
    fontSize: "0.8rem",
  },
  logo: {
    cursor: "pointer",
    width: "40%",
    maxWidth: 150,
    marginBottom: theme.spacing(6),
  },
  message: {
    marginTop: 0,
    marginBottom: 0,
  },
});
